
/* ---------------------------------
  PC時telリンク無効
--------------------------------- */
var ua = navigator.userAgent.toLowerCase();
var isMobile = /iphone/.test(ua)||/android(.+)?mobile/.test(ua);

if (!isMobile) {
    $('a[href^="tel:"]').on('click', function(e) {
        e.preventDefault();
    });
}


//メニュー開閉
$(".navInner").on('click.menuopen',function(){
    if($(this).children().hasClass('active')){
        menuSlideOut();
        //bodyFixReset();
    } else {
        menuSlideIn();
        //bodyFix();
    }
});



//メニュー開閉関数
function menuSlideIn() {
    $('.menu-trigger').addClass('active');
    $('.zheader_flexwrap').addClass('active');
    $('#menu').fadeIn(600);
    $('#head_logo').css({ 'position': 'fixed'});
}
function menuSlideOut() {
    $('.menu-trigger').removeClass('active');
    $('.zheader_flexwrap').removeClass('active');
    $('#head_logo').css({ 'position': 'relative'});
    $('#menu').fadeOut(600);
}

$(function() {
    $(window).on('load resize',function(){
        
    if (window.matchMedia('(min-width: 751px)').matches) {
        
        //PC表示の設定
        
        } else {

        $(".gnavul a").on('click',function(){
            menuSlideOut();
        });
        }

    });
});


document.addEventListener('DOMContentLoaded', function() {
  sal({
    threshold: 0.05
  });
});


// $(function() {
    
//       //URLのハッシュ値を取得
//       var urlHash = location.hash;
//       //ハッシュ値があればページ内スクロール
//       if(urlHash) {
//         //スクロールを0に戻す
//         $('body,html').stop().scrollTop(0);
//         setTimeout(function () {
//           //ロード時の処理を待ち、時間差でスクロール実行
//           scrollToAnker(urlHash) ;
//         }, 400);
//       }

//       //通常のクリック時
//       $('a[href^="#"].scroll').click(function() {
//         //ページ内リンク先を取得
//         var href= $(this).attr("href");
//         //リンク先が#か空だったらhtmlに
//         var hash = href == "#" || href == "" ? 'html' : href;
//         //スクロール実行
//         scrollToAnker(hash);
//         //リンク無効化
//         return false;
//       });

//       // 関数：スムーススクロール
//       // 指定したアンカー(#ID)へアニメーションでスクロール
//       function scrollToAnker(hash) {
//         var target = $(hash);
//         var position = target.offset().top;
//         $('body,html').stop().animate({scrollTop:position  - pagelink }, 200);
//       }
    
//  }); 

// //ページ内リンク
// var pagelink = 0;

$(window).on('load resize', function(){
    if (!window.matchMedia("(max-width:750px)").matches) {
        //PC表示の設定
        pagelink = 0;
    } else {
        //スマホ表示の設定
        pagelink = 0;
    }
});



/* ---------------------------------
  360px以下 viewport固定
--------------------------------- */

!(function () {
  const viewport = document.querySelector('meta[name="viewport"]');
  function switchViewport() {
    const value =
      window.outerWidth > 360
        ? 'width=device-width,initial-scale=1'
        : 'width=360';
    if (viewport.getAttribute('content') !== value) {
      viewport.setAttribute('content', value);
    }
  }
  addEventListener('resize', switchViewport, false);
  switchViewport();
})();
